import { type WindowHandlerInput } from 'supertokens-web-js/lib/build/windowHandler/types';

interface Dict {
  [key: string]: string;
}

let inmemstorage: Dict = {};

export const getWindowHandler: WindowHandlerInput = (original) => ({
  ...original,
  localStorage: {
    ...original.localStorage,
    key: async (index) => {
      try {
        return window.localStorage.key(index);
      } catch {
        return Object.keys(inmemstorage)[index];
      }
    },
    getItem: async (key) => {
      try {
        return window.localStorage.getItem(key);
      } catch {
        return inmemstorage[key] === undefined ? null : inmemstorage[key];
      }
    },
    clear: async () => {
      try {
        window.localStorage.clear();
      } catch {
        inmemstorage = {};
      }
    },
    removeItem: async (key) => {
      try {
        window.localStorage.removeItem(key);
      } catch {
        delete inmemstorage[key];
      }
    },
    setItem: async (key, value) => {
      try {
        window.localStorage.setItem(key, value);
      } catch {
        inmemstorage[key] = value;
      }
    },
    keySync: (index) => {
      try {
        return window.localStorage.key(index);
      } catch {
        return Object.keys(inmemstorage)[index];
      }
    },
    getItemSync: (key) => {
      try {
        return window.localStorage.getItem(key);
      } catch {
        return inmemstorage[key] === undefined ? null : inmemstorage[key];
      }
    },
    clearSync: () => {
      try {
        window.localStorage.clear();
      } catch {
        inmemstorage = {};
      }
    },
    removeItemSync: (key) => {
      try {
        window.localStorage.removeItem(key);
      } catch {
        delete inmemstorage[key];
      }
    },
    setItemSync: (key, value) => {
      try {
        window.localStorage.setItem(key, value);
      } catch {
        inmemstorage[key] = value;
      }
    },
  },
});
